import React from "react";

const Header = () => {
  return (
    <div className="px-0 sm:px-4  pt-4">
      <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
        Product sales report
      </h1>
    </div>
  );
};

export default Header;
